/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import {
  Button,
  Column,
  Editing,
  FilterRow,
  Pager,
  Paging,
  HeaderFilter,
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { gridModuloPaginaDataSource } from '../../ModulosServices';
import { Container } from './styles';

function Lista({ moduloNome, loading }) {
  const history = useHistory();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(7);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }

  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];

  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  return (
    <Container>
      <section>
        <div className="sec1">
          <h1>Páginas</h1>
          <p>
            Módulo: <strong>{moduloNome}</strong>
          </p>
        </div>
        <div className="add">
          <Link to="/page/register" className="link">
            <FaPlus />
          </Link>
        </div>
      </section>

      {loading ? (
        <Spinner
          color="dark"
          style={{ width: '3rem', height: '3rem', margin: '5% auto' }}
        />
      ) : (
        <DataGrid
          dataSource={gridModuloPaginaDataSource}
          remoteOperations
          showBorders
          allowColumnReordering
          allowColumnResizing
          columnAutoWidth
          onOptionChanged={handleOptionChange}
        >
          <Editing mode="row" useIcons allowDeleting />

          <Pager
            visible
            showPageSizeSelector
            allowedPageSizes={[7, 10, 15]}
            showInfo
          />
          <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
          <FilterRow
            visible={filterOptions.showFilterRow}
            applyFilter={filterOptions.currentFilter}
          />
          <Column
            dataField="id"
            caption="ID grupo"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="nome"
            caption="Nome grupo"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column type="buttons" caption="Ações" width={100}>
            <Button
              hint="Editar"
              visible
              icon="edit"
              onClick={(e) => history.push(`/page/update/${e.row.data.id}`)}
            />
            <Button name="delete" visible hint="Deletar" icon="trash" />
          </Column>
        </DataGrid>
      )}
    </Container>
  );
}

export default Lista;
